module.exports = __webpack_public_path__ + "img/emiarch-2.7e241c50.svg";